import dynamic from "next/dynamic";
import EmbeddedYoutubeAssetConfig from "./embedded-youtube-asset-config";
import EmbeddedYoutubeAssetAdvancedConfig from "./embedded-youtube-asset-advanced-config";
const EmbeddedYoutubeAssetComponent = dynamic(()=>import("./embedded-youtube-asset-component"));
export default {
    EmbeddedYoutubeAssetComponent,
    EmbeddedYoutubeAssetConfig,
    EmbeddedYoutubeAssetAdvancedConfig
};
